import { cn } from '../../../utils/cn';
import { useTranslation } from 'react-i18next';
import Info from '../icons/info';
import { Description as HeadlessDescription } from '@headlessui/react';

export default function Description({ className, error, content, children }) {
  const { t } = useTranslation();
  return (
    <HeadlessDescription
      className={cn(
        'text-important text-sm font-normal italic flex items-start gap-1 m-0',
        error && 'text-error',
        className
      )}
    >
      <span className={cn('min-w-4 min-h-4', error && 'rotate-180')}>
        <Info height='16' width='16' />
      </span>
      {error ? t(error) : children ? children : t(content)}
    </HeadlessDescription>
  );
}
